import AmexNaaMgmComponent from './AmexNaaMgmComponent';

export default AmexNaaMgmComponent;
